module.exports = __webpack_public_path__ + "img/ico_overview_right.26b3f455.svg";